import { isEmpty, size } from "lodash";

import { BASE_URL } from "../axios";
import ThumbNail from "../components/thumbNail/ThumbNail";
import { ScheduleIconComponent } from "../components";

import styles from "./config.module.scss";

export const columns = [
  {
    field: "id",
    renderCell: (row) => (
      <ThumbNail
        name={row.name}
        color={row.color}
        // className={cx(styles.thumbNail)}
        imgSrc={row.thumbnail_img}
        hasImage={!isEmpty(row.thumbnail_img)}
      />
    ),
    className: styles.image,
  },
  {
    field: "name",
    headerName: "Playlist",
  },
  {
    field: "songs",
    headerName: "Songs",
    renderCell: (row) => size(row.songs),
  },
  {
    field: "like",
    headerName: "Schedule",
    //replace div with absolute wrapper
    renderCell: (row) => <ScheduleIconComponent row={row} />,
    className: styles.likePageFavorite,
  },
];
